import React from "react";
import Card from "../components/Card";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { HashLink } from "react-router-hash-link";
import { TwitterShareButton, TwitterIcon, LineIcon } from "react-share";

import topTitle from "../images/topTitle.png";
import topImage from "../images/topImage.svg";
import about from "../images/aboutImage.png";
import timeline from "../images/timeline.png";
import sp_timeline from "../images/sp_timeline.png";
import photo02 from "../images/2021photo02.jpeg";
import photo03 from "../images/2021photo03.jpeg";
import photo04 from "../images/2021photo04.jpeg";
import photo05 from "../images/2021photo05.jpeg";
import step1 from "../images/step1.png";
import step2 from "../images/step2.png";
import step3 from "../images/step3.png";
import wave from "../images/wave.png";
import counter from "../images/counter.png";
import sp_counter from "../images/sp_counter.png";
import balloon from "../images/balloon.png";
import infoCard from "../images/infoCard.png";
import sp_infoCard from "../images/sp_infoCard.png";
import ribbonFront from "../images/ribbon-front.png";
import ribbonBack from "../images/ribbon-back.png";

const Top = (props) => {
  const medical_companies = !props.loading
    ? props.companies.contents.filter((item) => item.medical === true)
    : false;
  const general_companies = !props.loading
    ? props.companies.contents.filter((item) => item.medical === false)
    : false;
  const fakeCard = (datas) => {
    if (datas % 3 === 1) {
      return (
        <>
          <div class="fakeCard"></div>
          <div class="fakeCard"></div>
        </>
      );
    } else if (datas % 3 === 2) {
      return <div class="fakeCard"></div>;
    }
  };
  const renderDatas = !props.loading ? (
    <Tabs>
      <TabList>
        <Tab>全企業</Tab>
        <Tab>一般企業</Tab>
        <Tab>メディカル・医療・介護</Tab>
      </TabList>

      <TabPanel>
        {props.companies.contents.map((item) => (
          <>
            <Card data={item} />
          </>
        ))}
        {fakeCard(props.companies.contents.length)}
      </TabPanel>
      <TabPanel>
        {general_companies.map((item) => (
          <Card data={item} />
        ))}
        {fakeCard(general_companies.length)}
      </TabPanel>
      <TabPanel>
        {medical_companies.map((item) => (
          <Card data={item} />
        ))}
        {fakeCard(medical_companies.length)}
      </TabPanel>
    </Tabs>
  ) : null;
  return (
    <>
      <Navbar />
      <div className="shareContainer">
        <li>
          <TwitterShareButton
            title="【北海道・札幌の求人】お仕事探しなら道新適職フェア"
            url="https://tekisyoku-fair.web.app/"
          >
            <TwitterIcon size={32} round={true} />
            <p>Twitterでシェア</p>
          </TwitterShareButton>
        </li>
        <li>
          <a href="http://line.me/R/msg/text/?【北海道・札幌の求人】お仕事探しなら道新適職フェア　https://tekisyoku-fair.web.app/">
            <LineIcon size={32} round={true} />
            <p>LINEでシェア</p>
          </a>
        </li>
      </div>
      <div className="topContainer" id="top">
        <div className="inner topFlex">
          <img src={topTitle} alt="" className="topTitle" />
          <img src={topImage} alt="" />
        </div>
        <div className="moveContainer">
          <p className="move">DOSHIN TEKISYOKU FAIR</p>
          <p className="move">DOSHIN TEKISYOKU FAIR</p>
          <p className="move">DOSHIN TEKISYOKU FAIR</p>
        </div>
      </div>
      <div className="inner infoCardContainer">
        <img src={infoCard} alt="" className="infoCard" />
        <img src={sp_infoCard} alt="" className="sp_infoCard" />
      </div>
      <div className="inner anchorLinkContainer">
        <div>
          <img src={ribbonFront} className="ribbon-front ribbon" alt="" />
          <img src={ribbonBack} className="ribbon-back ribbon" alt="" />
          <HashLink smooth to="#joblist" className="green">
            <p>
              求人情報一覧<span>はこちら</span>
              <i className="far fa-arrow-alt-circle-down"></i>
            </p>
          </HashLink>
        </div>
        <div>
          <img src={ribbonFront} className="ribbon-front ribbon" alt="" />
          <img src={ribbonBack} className="ribbon-back ribbon" alt="" />
          <HashLink smooth to="#place" className="yellow">
            <p>
              会場の情報<span>はこちら</span>
              <i className="far fa-arrow-alt-circle-down"></i>
            </p>
          </HashLink>
        </div>
      </div>
      <div className="photoContainer">
        <div className="move">
          <img src={photo02} alt="fairImage" />
          <img src={photo03} alt="fairImage" />
          <img src={photo04} alt="fairImage" />
          <img src={photo05} alt="fairImage" />
        </div>
        <div className="move">
          <img src={photo02} alt="fairImage" />
          <img src={photo03} alt="fairImage" />
          <img src={photo04} alt="fairImage" />
          <img src={photo05} alt="fairImage" />
        </div>
      </div>

      <div className="inner aboutContainer">
        <span className="mainTitle">道新適職フェアとは</span>
        <div className="aboutFlex">
          <div className="about-left">
            <img src={about} alt="about" />
          </div>

          <div className="about-right">
            <p className="aboutTitle">
              北海道新聞紙面と連動する
              <br />
              就職・転職イベントです。
            </p>
            <p className="description">
              北海道新聞社が主催する道新適職フェア「合同就職説明会」は、就職・転職を考える方のための求人情報フェアです。
              毎年、医療・介護等のメディカル企業や一般企業を対象にした適職フェア「合同就職説明会」を開催しています。
              <br />
              参加企業の人事担当者と直接会って話ができる企業ブースはもちろん、就職・転職に役立つ実践的なセミナーやプロのカウンセラーによる就職・転職無料相談コーナーなど。毎回、多彩なイベント内容を企画し、開催いたします。
              <br />
              就職・転職を考えるなら、ぜひ道新適職フェア「合同就職説明会」へご来場下さい。
              <br />
              多くの皆さまのご参加をお待ちしています。
            </p>
          </div>
        </div>
      </div>
      <div className="inner aboutContainer">
        <span className="subTitle">今後の予定</span>
        <p className="announce">
          ※新型コロナウイルス等の感染状況によっては、急遽中止になる場合があります。また、開催日時および内容を変更する場合があります。
        </p>
        <img src={timeline} alt="今後の予定" class="pc_timeline" />
        <img src={sp_timeline} alt="今後の予定" class="sp_timeline" />
      </div>
      <div className="inner howtoContainer" id="howto">
        <span className="subTitle">参加方法</span>
        <div className="stepContainer">
          <div className="step one">
            <img src={step1} alt="ステップ１" />
            <div className="step-info">
              <div className="number">1</div>
              <h3>仕事どうしよう・・・</h3>
              <h3>やりたいことを見つけたい！</h3>
            </div>
          </div>
          <div className="iconContainer icon1">
            <i className="fas fa-arrow-right"></i>
          </div>
          <div className="step two">
            <img src={step2} alt="ステップ２" />
            <div className="step-info">
              <div className="number">2</div>
              <h3>出展企業・イベントをチェック</h3>
              <p>
                予約は必要ありません。お話を聞きたい企業が見つかりましたら是非会場へ足を運んでみてください。無料相談コーナ−だけの参加も大歓迎！
              </p>
              <HashLink smooth to="#joblist" className="yellow">
                求人情報はこちら<i className="far fa-arrow-alt-circle-down"></i>
              </HashLink>
            </div>
          </div>
          <div className="iconContainer icon2">
            <i className="fas fa-arrow-right"></i>
          </div>
          <div className="step three">
            <img src={step3} alt="ステップ３" />
            <div className="step-info">
              <div className="number">3</div>
              <h3>イベント会場に足を運ぶ</h3>
              <p>
                就職・転職に少しでもお悩みの方はどなたでも参加できます。お買い物ついででも構いません！是非、気楽にご参加下さい。お待ちしています。
              </p>
              <HashLink smooth to="#place" className="yellow">
                会場の情報<i className="far fa-arrow-alt-circle-down"></i>
              </HashLink>
            </div>
          </div>
        </div>
      </div>
      <img src={wave} alt="" className="wave" />
      <div className="inner companyContainer" id="joblist">
        <span className="subTitle">求人一覧</span>
        {renderDatas}
      </div>
      <div className="inner placeContainer" id="place">
        <span className="subTitle">開催会場</span>
        <div className="iframeFlex">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11660.106628545936!2d141.3529264!3d43.0619069!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1d788fff690ef438!2z6YGT5paw44OX44Op44K2IERPLUJPWA!5e0!3m2!1sja!2sjp!4v1672027816861!5m2!1sja!2sjp" 
            allowFullScreen=""
            loading="lazy"
            title="map"
          ></iframe>
          <div className="iframe-text">
            <p>道新プラザ DO-BOX</p>
            <p className="mt">札幌市中央区大通西３丁目６</p>
            <p>北海道新聞社北一条館 1階（道新プラザ内）</p>
          </div>
        </div>
      </div>
      <div className="inner counterContainer" id="infection">
        <span className="subTitle">
          新型コロナウイルス
          <br className="sp" />
          感染症対策について
        </span>
        <img src={counter} alt="" className="counterImage" />
        <img src={sp_counter} alt="" className="sp_counterImage" />
      </div>
      <div className="QandAContainer">
        <div className="inner">
          <span className="subTitle">よくある質問</span>
        </div>
        <img src={balloon} alt="" className="balloon" />
        <img src={balloon} alt="" className="balloon" />
        <img src={balloon} alt="" className="balloon" />
        <img src={balloon} alt="" className="balloon" />
        <div className="QandA">
          <p className="question">当日の持ち物はありますか？</p>
          <p className="answer">
            特にありません。企業さんのブースを訪問する前に複写式の訪問カードをお渡しいたします。ご記入いただき面談の際に企業のご担当者様にお渡し下さい。
          </p>
          <p className="question">当日の服装はスーツですか？</p>
          <p className="answer">
            スーツでなくても構いません。例年、お買い物のついでに寄られる方などもいらっしゃいますので、服装は自由です。
          </p>
          <p className="question">事前の予約は必要ですか？</p>
          <p className="answer">
            必要ありません。ご都合の良い時間にご来場ください。
          </p>
          <p className="question">
            当日都合が悪く合同説明会に行けないのですが、どうしたらいいですか？
          </p>
          <p className="answer">
            お話を聞きたい参加予定企業さんに直接ご連絡してみてください。　　　
          </p>
        </div>
      </div>
      <div className="inner contactContainer" id="contact">
        <span className="subTitle">お問い合わせ</span>
        <div className="contact-data">
          <p className="contact-desc">
            道新適職フェアに関するお問い合わせは下記の電話、Email、またはお問い合わせフォームをご利用ください。
          </p>
          <p>
            ※お問い合わせでいただいた個人情報に関しては、お問い合わせに関わるご連絡以外の用途には使用致しません。
          </p>
          <div className="contact-info-flex">
            <span></span>
            <p>お気軽にお問い合わせください！！</p>
            <span></span>
          </div>
          <p className="contact-tel">
            TEL : <a href="tel:011-727-6001">011-727-6001</a>
          </p>
          <p className="note">(株式会社アド・ビューロー岩泉)</p>
          <p className="contact-tel">
            Email :{" "}
            <a href="mailto:do-tekisyoku@iwaizumi.co.jp">
              do-tekisyoku@iwaizumi.co.jp
            </a>
          </p>
          <p className="toContact">お問い合わせフォーム</p>
          <div className="buttonContainer">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeWiw4uTAtZ-a1UjXaAKopaJgFiCvP8JHVkM5U3YJ8L3J6HHA/viewform?usp=sf_link"
              target="_blank"
              rel="noreferrer"
            >
              <button>
                お問い合わせ<i className="fas fa-external-link-square-alt"></i>
              </button>
            </a>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSf2zF6XtqhJtkNSdzero9d_2Ii2oONWDPvJDtl7ekkZzfB1-w/viewform?usp=sf_link"
              target="_blank"
              rel="noreferrer"
            >
              <button>
                企業様はこちら
                <i className="fas fa-external-link-square-alt"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Top;
